import React from 'react';
import { Checkbox } from './ui/checkbox';
import { Label } from './ui/label';

/**
 * Опциональный чекбокс согласия на рекламные рассылки (не предустановлен).
 */
const MarketingConsent = ({
  id = 'marketing-consent',
  checked = false,
  onCheckedChange,
  className = '',
}) => (
  <div className={className}>
    <div className="flex items-start gap-2">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
      />
      <Label htmlFor={id} className="text-sm font-normal leading-5 text-muted-foreground cursor-pointer">
        Согласен на получение рекламных рассылок и персональных предложений
      </Label>
    </div>
  </div>
);

export default MarketingConsent;
